"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geologist = void 0;
class Geologist {
    constructor() {
        this.name = 'Geologist';
        this.description = 'Have at least 3 tiles on or adjacent to volcanic areas';
    }
    getScore(player) {
        const board = player.game.board;
        const volcanicSpaceIds = board.getVolcanicSpaceIds();
        let eligibleSpacesOccupiedByPlayer = board.spaces.filter((s) => volcanicSpaceIds.includes(s.id) && s.player === player && s.tile !== undefined);
        volcanicSpaceIds.forEach((spaceId) => {
            const space = board.getSpace(spaceId);
            const eligibleAdjacentSpaces = board.getAdjacentSpaces(space).filter((adjSpace) => adjSpace.player === player && adjSpace.tile !== undefined);
            eligibleSpacesOccupiedByPlayer = eligibleSpacesOccupiedByPlayer.concat(eligibleAdjacentSpaces);
        });
        const score = new Set(eligibleSpacesOccupiedByPlayer).size;
        return score;
    }
    canClaim(player) {
        return this.getScore(player) >= 3;
    }
}
exports.Geologist = Geologist;
//# sourceMappingURL=Geologist.js.map